<!--标签1-->
<template>
  <div class="custom-label">
    <bread-crumb-cas
      :routeList="breadArray"
      labelType="custom"
    ></bread-crumb-cas>
    <!--
       isShowSelect
        -->
    <top-bar
      :isShowSelect="isShowSelect"
      placeholder="请选择所属业务"
      :data="data"
      :clickAddButton="clickAddButton"
      @selectChange="selectChange"
      :selectValues="selectValue"
      @getDefaultValue="getDefaultValue"
    ></top-bar>
    <base-table :tableData="tableData" @handleClick="handleClick"></base-table>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    >
    </pagination>
    <modal
      :isShow.sync="dialogShowLabel"
      :title="title"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="addClickHandler"
      @one="handleDialogLabel(false)"
      @update:isShow="handleDialogLabel(false)"
      @two="handleDialogSubmitLabel"
    >
      <div class="base-dialog">
        <el-form
          :model="formList"
          :rules="rules"
          class="demo-ruleForm"
          label-width="80px"
          ref="classifyName"
        >
          <el-form-item label="分类名称" prop="nameValue">
            <el-input
              v-model="formList.nameValue"
              class="base-dialog-input"
              :class="{ 'base-dialog-input-border': isRed }"
              autocomplete="off"
              type="text"
              placeholder="请输入"
              maxlength="30"
              show-word-limit
            ></el-input>
            <span class="rules" v-show="isRed"
              ><i class="el-icon-warning-outline"></i>分类名称不可重复</span
            >
          </el-form-item>
        </el-form>
      </div>
    </modal>

    <modal
      :isShow.sync="deleteDialog"
      title="删除"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="deleteClickHandler"
    >
      <div class="dialogVal">确认删除</div>
    </modal>
    <modal
      :isShow.sync="attributeShow"
      title="属性"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="btnTextClickHandler"
    >
      <div class="dialogVal">
        <el-checkbox-group v-model="checkedCities" @change="changeCheck">
          <el-checkbox
            v-for="item in checkList"
            :key="item.id"
            :label="item.id"
            >{{ item.name }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
    </modal>
  </div>
</template>

<script>
import pagination from "../../../../../components/pagination";
import topBar from "../../../../../components/topBar";
import baseTable from "../../../../../components/baseTable";
import breadCrumbCas from "../../../../../components/breadCrumbCas";
import modal from "../../../../../components/modal";
import {
  saveOrUpdateLabelGroup,
  pageContentLabelGroups,
  deleteLabelGroupById,
  saveOrUpdateContentLabel,
  pageContentLabelsByGroupId,
  deleteContentLabelById,
  listContentBizDetailByPin,
  listContentBusinessForUserMan,
  getTagAttributes,
} from "../../../../../api/man.js";
import { mapState } from "vuex";

export default {
  name: "commonLabel",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入名称"));
      } else {
        callback();
      }
    };
    return {
      title: "",
      isRed: false,
      selectValue: "",
      rules: {
        nameValue: [
          { required: true, message: "分类名称不能为空", trigger: "change" },
        ],
      },
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      tableData: {
        tableList: [],
        tableHeader: [
          {
            label: "分类ID",
            prop: "id",
          },
          {
            label: "分类名称",
            prop: "name",
          },
          {
            label: "所属业务",
            prop: "contentBusinessName",
          },
          {
            label: "创建时间",
            prop: "createTime",
          },
          {
            label: "创建人",
            prop: "createUser",
          },
        ],
        tableType: 4,
        shuType: 1,
      },
      isShowSelect: true,
      tableId: "",
      // 删除弹框
      deleteDialog: false,
      attributeShow: false, // 属性弹窗
      data: [],
      times: null,
      tableVal: {},
      btnText: ["取消", "确认"],
      isShowBtn: [true, true, false],
      nameValue: "",
      dialogShow: false,
      dialogShowLabel: false,
      formList: {
        nameValue: "",
        // nameType: "",
      },
      checkList: [
        {
          id: 2,
          name: "写手端不可见",
        },
        {
          id: 3,
          name: "C端用户不可见",
        },
      ],
      checkedCities: [],
      contentBusinessId: "",
      invisibleStatus: "",
      // rules: {
      //   nameValue: [
      //     {validator: validatePass, trigger: 'blur'}
      //   ],
      // }
      breadArray: [
        {
          name: "标签管理",
          path: "",
          query: undefined,
        },
        {
          name: "业务自定义标签",
          path: "/customLabel/cusGroup",
          query: this.$router.query,
        },
      ],
    };
  },
  components: {
    baseTable,
    topBar,
    breadCrumbCas,
    modal,
    pagination,
  },
  watch: {
    "formList.nameValue"(newValue, oldValue) {
      //
      if (this.$utils.specialCharacters(newValue)) {
        this.$message({
          message: "禁止输入特殊字符",
          type: "warning",
        });
        this.formList.nameValue = this.$utils.removalSpace(newValue);
      }
    },
    formList: {
      handler(newValue, oldValue) {
        this.isRed = false;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleClick(val) {
      if (val.type === "edit") {
        this.tableId = val.val.id;
        this.formList.nameValue = val.val.name;
        this.dialogShowLabel = true;
        this.title = "编辑";
        this.tableVal = val.val;
        this.isRed = false;
      } else if (val.type === "goAdmin") {
        // 跳转一级标签路由
        this.$router.push({
          path: `/customLabels/1`,
          query: { groupId: val.val.id },
        });
      } else if (val.type === "delete") {
        this.deleteDialog = true;
        this.tableVal = val.val;
      } else if (val.type === "attribute") {
        this.attributeShow = true;
        this.tableVal = val.val;
        // 属性值回显
        if (val.val.invisibleStatus !== 1) {
          if (val.val.invisibleStatus == 4) {
            this.checkedCities = [2, 3];
          } else {
            this.checkedCities = [val.val.invisibleStatus];
          }
        }
        this.invisibleStatus = val.val.invisibleStatus;
      }
    },
    // 删除弹框
    deleteClickHandler(val) {
      if (val === "one") {
        this.deleteDialog = false;
      } else if (val === "two") {
        this.deleteLabelGroupById(this.tableVal);
        this.deleteDialog = false;
      }
    },
    // 删除
    deleteLabelGroupById(val) {
      deleteLabelGroupById({
        tenantId: this.$commonJs.getTenantId(),
        labelGroupId: val.id,
      })
        .then((res) => {
          if (res) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
          }
          this.paginationDataProduct.currentPage = 1;
          this.pageContentLabelGroups(this.contentBusinessId);
        })
        .catch((res) => {
          // if(res.data===-1) {
          this.$message.error(res.msg);
          // }
        });
    },
    changeCheck(val) {
      let numStatus = val.toString();
      let numStr1 = "2,3";
      let numStr2 = "3,2";
      if (numStatus == numStr1 || numStatus == numStr2) {
        this.invisibleStatus = 4;
      } else {
        this.invisibleStatus = numStatus;
      }
    },
    // 属性弹窗
    btnTextClickHandler(val) {
      if (val === "one") {
        this.attributeShow = false;
        this.checkedCities = [];
      } else if (val === "two") {
        if (this.invisibleStatus == "") {
          this.invisibleStatus = "1";
        }
        getTagAttributes({
          tenantId: this.tableVal.tenantId,
          id: this.tableVal.id,
          invisibleStatus: this.invisibleStatus,
          // updateInvisibleStatusType: this.tableVal.yn
        })
          .then((res) => {
            if (res) {
              this.checkedCities = [];
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.attributeShow = false;
            }
            this.pageContentLabelGroups(this.contentBusinessId);
          })
          .catch((err) => {
            this.$message.error("操作失败");
          });
        this.attributeShow = false;
      }
    },
    selectChange(data) {
      this.contentBusinessId = data;
      this.pageContentLabelGroups(data);
    },
    getDefaultValue(val) {
      this.pageContentLabelGroups(this.contentBusinessId);
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.pageContentLabelGroups(this.contentBusinessId);
    },
    // 新增弹框
    addClickHandler(val) {
      let vm = this;
      if (val === "one") {
        this.dialogShowLabel = false;
      } else if (val === "two") {
        this.$refs.classifyName.validate((valid) => {
          if (valid) {
            vm.saveOrUpdateLabelGroup(vm.formList.nameValue, vm.tableId);
          } else {
            return false;
          }
        });
      }
    },
    //
    listContentBusinessForUserMan() {
      listContentBusinessForUserMan({
        tenantId: this.$commonJs.getTenantId(),
      }).then((res) => {
        let valList = [];
        this.data.splice(0, this.data.length);
        res?.contentBusinesses?.map((item) => {
          valList.push({
            value: item.id,
            label: item.name,
          });
        });
        this.contentBusinessId = res?.contentBusinesses?.[0].id;
        this.data = valList;
        this.selectValue = this.data[0];
      });
    },
    // 分页
    pageContentLabelGroups(data) {
      let vm = this;
      if (data) {
        pageContentLabelGroups({
          tenantId: this.$commonJs.getTenantId(),
          labelType: 2,
          contentBusinessId: this.contentBusinessId,
          // page:2,
          // pageSize:10
          pageNo: this.paginationDataProduct.currentPage,
          pageSize: this.paginationDataProduct.pageSize,
        }).then((res) => {
          console.log("🚀 ~ pageContentLabelGroups ~---387 --- res:", res);
          this.tableData.tableList.splice(0, this.tableData.tableList.length);
          res.data.map((item) => {
            this.tableData.tableList.push(item);
          });
          vm.paginationDataProduct.total = res.totalCount;
          vm.paginationDataProduct.currentPage = res.pageNo;
          vm.paginationDataProduct.pageSize = res.pageSize;
        });
      }
    },
    clickAddButton() {
      if (!this.data || !this.data.length) {
        this.$message.error("请先添加业务！");
        return;
      }

      this.tableId = "";
      this.title = "新增";
      this.tableVal = {};
      this.formList.nameValue = "";
      this.dialogShowLabel = true;
      this.isRed = false;
    },
    handleDialog(val) {
      this.dialogShow = val;
    },
    handleDialogLabel(val) {
      this.dialogShowLabel = val;
    },
    handleDialogSubmit() {
      this.handleDialog(false);
    },
    handleDialogSubmitLabel() {
      this.handleDialogLabel(false);
    },
    // 新增
    saveOrUpdateLabelGroup(name, id) {
      if (this.$utils.isEmpty(this.contentBusinessId)) {
        this.$message.error("业务不存在");
      }
      if (name && name.trim() != "") {
        saveOrUpdateLabelGroup({
          labelType: 2,
          contentBusinessId: this.contentBusinessId,
          name: name,
          tenantId: this.$commonJs.getTenantId(),
          id: id,
        })
          .then((res) => {
            if (res?.success) {
              this.$message.success("添加成功");
            }
            this.pageContentLabelGroups(this.contentBusinessId);
            this.isRed = false;
            this.dialogShowLabel = false;
          })
          .catch((err) => {
            if (err.code === "1901") {
              this.isRed = true;
            }
          });
      } else {
        this.$message.error("请输入标签名称");
      }
    },
    // 获取用户开通的业务、栏目、频道信息
    // listContentBizDetailByPin() {
    //   listContentBizDetailByPin({
    //     tenantId: this.$commonJs.getTenantId()
    //   })
    //     .then(res => {
    //       console.log(res);
    //     })
    // }
  },
  created() {
    // this.listContentBizDetailByPin()
    this.getDefaultValue();
    this.pageContentLabelGroups(this.contentBusinessId);
    this.listContentBusinessForUserMan();
  },
};
</script>

<style lang="scss" scoped>
.dialogVal {
  color: #5f5f6b;
  font-size: 16px;
  padding: 30px 0px;
  padding-bottom: 0px;
  text-align: center;
}

.common-audit-tabel {
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  background: white;
  margin-top: 14px;
}

.input-container {
  display: flex;
  justify-content: center;
  padding-top: 20px;

  .input-suffix {
    .el-input {
      width: 276px;
    }
  }
}

.base-dialog {
  width: 400px;
  padding: 30px 26px 0;
  position: relative;
  font-size: 14px;
  color: #2c3443;

  &-input {
    width: 276px;
  }

  &-textarea {
    width: 276px;
    padding-top: 10px;
  }

  .el-form-item__label {
    width: 68px;
    font-weight: bolder;
  }

  .el-input__inner {
    height: 32px;
  }

  // .el-form-item__error {
  //   left: 68px;
  // }
  &__body {
    padding: 30px 26px;
  }

  &__header {
    background-color: #f7f8fb;
    height: 46px;
    display: flex;
    align-items: center;

    .el-dialog__title {
      font-size: 16px;
      color: #333840;
      font-weight: bolder;
    }
  }
}

:deep(.base-dialog-input-border) {
  position: relative;

  & > input {
    // background: #F56C6C;
    border: 1px solid #f56c6c !important;
  }
}

.rules {
  position: absolute;
  font-size: 0.5em;
  color: #f56c6c;
  bottom: -28px;
  left: 0px;
}
</style>
